import {
    useLogout,
    useNavigate,
    Icon,
    useLocation,
    matchesPath,
} from "@for-it/web-lib";
import { useState } from "react";
import logo from "../../assets/logo.png";
import { Routes } from "../../routes.tsx";

export function AdminPanelSidebar() {
    const logout = useLogout();
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleLogout = async () => {
        await logout();
        navigate.toRoute(Routes.LOGIN.path());
    };

    const isActive = (routePath: string) =>
        matchesPath(routePath, location.pathname);

    return (
        <div className="overflow-y-hidden">
            <div className="md:hidden p-2 bg-blue-400 flex justify-between items-center fixed top-0 left-0 right-0 z-50">
                <button
                    onClick={() => setIsMenuOpen((prev) => !prev)}
                    className="text-white"
                >
                    <div className="w-6 h-1 bg-white mb-1"></div>
                    <div className="w-6 h-1 bg-white mb-1"></div>
                    <div className="w-6 h-1 bg-white"></div>
                </button>
            </div>

            <aside
                className={`bg-blue-400 h-full fixed top-0 left-0 w-full md:w-64 transform transition-transform duration-300 ease-in-out z-50 ${
                    isMenuOpen ? "translate-x-0" : "-translate-x-full"
                } md:translate-x-0 md:static`}
            >
                <div className="p-5 flex flex-col h-full">
                    {isMenuOpen && (
                        <button
                            onClick={() => setIsMenuOpen(false)}
                            className="text-white text-2xl absolute top-4 right-4 md:hidden"
                        >
                            <Icon name="bx-x" className="text-3xl" />
                        </button>
                    )}
                    <div
                        className="flex justify-center mb-6 cursor-pointer"
                        onClick={() => navigate.toRoute(Routes.HOME.path())}
                    >
                        <img src={logo} alt="logo amia" className="h-12" />
                    </div>
                    <nav className="flex-grow">
                        <div className="space-y-2">
                            <div>
                                <button
                                    type="button"
                                    onClick={() => {
                                        navigate.toRoute(Routes.HOME.path());
                                        setIsMenuOpen(false);
                                    }}
                                    className="w-full text-left text-md font-bold flex items-center justify-between py-1"
                                >
                                    <span
                                        className={`text-xl md:text-lg ${
                                            isActive(Routes.HOME.path())
                                                ? "text-blue-900"
                                                : "text-white"
                                        }`}
                                    >
                                        Dashboard
                                    </span>
                                </button>
                            </div>

                            <div>
                                <button
                                    type="button"
                                    onClick={() => {
                                        navigate.toRoute(
                                            Routes.TENANTS_LIST.path(),
                                        );
                                        setIsMenuOpen(false);
                                    }}
                                    className="w-full text-left text-md font-bold flex items-center justify-between py-4 md:py-1"
                                >
                                    <span
                                        className={`text-xl md:text-lg ${
                                            isActive(Routes.TENANTS_LIST.path())
                                                ? "text-blue-900"
                                                : "text-white"
                                        }`}
                                    >
                                        Tenants
                                    </span>
                                </button>
                            </div>
                        </div>
                    </nav>
                    <div className="flex flex-col gap-2 border-t border-white/10 p-2">
                        <div>
                            <button
                                type="button"
                                onClick={() => {
                                    navigate.toRoute(
                                        Routes.CHANGE_PASSWORD.path(),
                                    );
                                    setIsMenuOpen(false);
                                }}
                                className="w-full text-left text-md font-bold flex items-center justify-between py-4 md:py-0"
                            >
                                <span
                                    className={`text-xl md:text-lg ${
                                        isActive(Routes.CHANGE_PASSWORD.path())
                                            ? "text-blue-900"
                                            : "text-white"
                                    }`}
                                >
                                    Cambiar Contraseña
                                </span>
                            </button>
                        </div>
                        <button
                            type="button"
                            className="text-left py-4 md:py-0"
                            onClick={handleLogout}
                        >
                            <span className="text-white text-xl md:text-lg font-bold hover:text-blue-800">
                                Cerrar Sesión
                            </span>
                        </button>
                    </div>
                </div>
            </aside>

            {isMenuOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
                    onClick={() => setIsMenuOpen(false)}
                ></div>
            )}
        </div>
    );
}
